import { useState } from "react";

export function BeforeAfterSlider({ beforeImage, afterImage, title, description, testIdPrefix }) {
  const [position, setPosition] = useState(50);

  return (
    <div className="rounded-[2rem] border border-white/60 bg-white/90 p-4 shadow-[0_20px_80px_rgba(16,24,40,0.08)]" data-testid={`${testIdPrefix}-card`}>
      <div className="relative aspect-[4/3] overflow-hidden rounded-[1.5rem]" data-testid={`${testIdPrefix}-visual`}>
        <img alt={`${title} after`} className="h-full w-full object-cover" data-testid={`${testIdPrefix}-after-image`} src={afterImage} />
        <img
          alt={`${title} before`}
          className="absolute inset-0 h-full w-full object-cover"
          data-testid={`${testIdPrefix}-before-image`}
          src={beforeImage}
          style={{ clipPath: `inset(0 ${100 - position}% 0 0)` }}
        />
        <div className="pointer-events-none absolute inset-y-0" style={{ left: `calc(${position}% - 1px)` }}>
          <div className="relative h-full w-0.5 bg-white/90 shadow-[0_0_0_1px_rgba(0,0,0,0.08)]">
            <div className="absolute left-1/2 top-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-white/80 bg-slate-950 text-xs font-semibold uppercase tracking-[0.2em] text-white shadow-lg">
              ↔
            </div>
          </div>
        </div>
        <div className="absolute left-4 top-4 rounded-full bg-slate-950/80 px-3 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-white" data-testid={`${testIdPrefix}-before-badge`}>
          Before
        </div>
        <div className="absolute right-4 top-4 rounded-full bg-primary px-3 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-foreground" data-testid={`${testIdPrefix}-after-badge`}>
          After
        </div>
        <input
          aria-label={`${title} comparison slider`}
          className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
          data-testid={`${testIdPrefix}-range-input`}
          max="100"
          min="0"
          onChange={(event) => setPosition(Number(event.target.value))}
          type="range"
          value={position}
        />
      </div>

      <div className="space-y-3 px-1 pt-5">
        <h3 className="text-2xl font-bold text-foreground" data-testid={`${testIdPrefix}-title`}>
          {title}
        </h3>
        <p className="text-sm text-muted-foreground" data-testid={`${testIdPrefix}-description`}>
          {description}
        </p>
      </div>
    </div>
  );
}